'use strict';

module.exports = require('../../utils/binarySearch').bind(null, [1, 1.5, 2.25, 3.38, 5.06, 7.59, 11.39, 17.09, 25.63, 38.44, 57.67, 86.5, 129.75, 194.62, 291.93, 437.89, 656.84, 985.26, 1477.89, 2216.84, 3325.26, 4987.89, 77481.83]);


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/storage/LatencyCache/findIndex.js
// module id = 722
// module chunks = 10